import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowRight } from 'lucide-react';
import { companyInfo } from '../mockData';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-emerald-900 via-teal-900 to-emerald-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Elegant Grid Layout */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <Logo textColor="text-white" />
            </div>
            <p className="text-emerald-200 text-sm leading-relaxed mb-6">
              Your trusted partner for Print on Demand and fulfillment excellence.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm">
                <div className="w-1.5 h-1.5 bg-teal-400 rounded-full"></div>
                <span>Quality Focused</span>
              </div>
              <div className="flex items-center space-x-2 text-sm">
                <div className="w-1.5 h-1.5 bg-emerald-400 rounded-full"></div>
                <span>Fast Processing</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 flex items-center space-x-2">
              <div className="w-1 h-6 bg-gradient-to-b from-emerald-400 to-teal-400 rounded-full"></div>
              <span>Quick Links</span>
            </h3>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'About Us', path: '/about' },
                { name: 'FAQ', path: '/faq' },
                { name: 'Contact', path: '/contact' }
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path} 
                    className="group flex items-center space-x-2 hover:text-emerald-300 transition-colors"
                  >
                    <ArrowRight size={14} className="opacity-0 group-hover:opacity-100 -ml-4 group-hover:ml-0 transition-all" />
                    <span>{link.name}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 flex items-center space-x-2">
              <div className="w-1 h-6 bg-gradient-to-b from-teal-400 to-emerald-400 rounded-full"></div>
              <span>Services</span>
            </h3>
            <ul className="space-y-3 text-sm">
              {[
                { name: 'Print on Demand', hash: '#print-on-demand' },
                { name: 'Dropshipping', hash: '#dropshipping' },
                { name: 'Product Sourcing', hash: '#product-sourcing' },
                { name: 'Global Warehousing', hash: '#global-warehousing' },
                { name: 'Custom Branding', hash: '#custom-branding' }
              ].map((service) => (
                <li key={service.hash}>
                  <Link 
                    to={`/services${service.hash}`}
                    className="hover:text-emerald-300 transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 flex items-center space-x-2">
              <div className="w-1 h-6 bg-gradient-to-b from-emerald-400 to-teal-400 rounded-full"></div>
              <span>Contact Us</span>
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-emerald-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-emerald-100">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-teal-400 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm hover:text-emerald-300 transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-emerald-400 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-emerald-300 transition-colors break-all">
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-emerald-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-emerald-200">
              &copy; {currentYear} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-sm text-emerald-200">
              Made for entrepreneurs worldwide
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;